import React, {useRef, useState} from 'react';

import './DivMenu.less';
import IconButton from "../IconButton/IconButton";
import Icons from "../IconButton/Icons";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import {ContextMenuItemProps} from "./ContextMenuItem";
import type {VoidAnyCallback, VoidEventCallback} from "../../@types/functions";

const DivMenu: React.FC<DivMenuProps> = (props) => {
    const [open, setOpen] = useState<boolean>(true);
    const saveRef = useRef<any>(null);

    const afterClick = (e: Event) => {
        e.preventDefault();
        e.stopPropagation();

        setOpen(false);

        setTimeout(() => {
            props.onSelection(e);
            props.onClose?.(e);
        }, 100);
    };

    const onClick = (e: Event, onClickMethod: VoidEventCallback) => {
        e.preventDefault();
        e.stopPropagation();

        // Close menu
        afterClick(e);

        // Call the action handler for this item
        onClickMethod(e);
    };

    const renderItem = (item: ContextMenuItemProps) => {
        if (item.subItems) {
            const subItems = item.subItems.map(item => {
                return (
                    <IconButton key={item.label}
                                className="div-menu__child"
                                type={item.icon}
                                label={item.label}
                                color={item.color}
                                textColor={item.color}
                                onClick={(e) => onClick(e, item.onClick)}
                    />
                );
            });

            return (
                [
                    <IconButton key={item.label}
                                className="div-menu__parent"
                                type={item.icon}
                                label={item.label} // ... is added by CSS ::after
                                color={item.color}
                                onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();

                                    const style = document.getElementById(`DivMenuChild-${item.label}`).style;
                                    style.display = (style.display !== 'block') ? 'block' : 'none';
                                }}
                    />,
                    <div key={item.label + 'Kids'} id={`DivMenuChild-${item.label}`} className="div-menu__children">
                        {subItems}
                    </div>
                ]
            );
        }
        else return (
            <IconButton type={item.icon}
                        label={item.label}
                        color={item.color}
                        onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            onClick(e, item.onClick);
                        }}
            />
        );

    };

    const onClickAway = (e) => {
        if (props.onClickAway) {
            props.onClickAway(e);
        }
    };

    const menu = props.items.map((item) => (
        <div key={item.label} className="MenuItem">
            {renderItem(item)}
        </div>
    ));

    return (
        <div className="div-menu__outer" ref={saveRef}>
            {open &&
                <ClickAwayListener mouseEvent="onMouseDown"
                                   touchEvent="onTouchStart"
                                   onClickAway={onClickAway}
                >
                    <div className={`div-menu ${props.noClose ? 'noClose' : ''}`}>
                        {!props.noClose && <IconButton className="div-menu__close"
                                                            key="Close"
                                                            label="Close"
                                                            labelBold={true}
                                                            type={Icons.CLOSE}
                                                            onClick={props.onClose}
                        />}
                        {menu}
                    </div>
                </ClickAwayListener>
            }
        </div>

    );
};

export type DivMenuProps = {
    items: ContextMenuItemProps[],
    noClose?: boolean, // if true, do not show a close button
    onClose?: VoidAnyCallback, // passed by dialog
    onClickAway?: Function, // click away function
    onSelection: Function
}
;

export default DivMenu;
